import http from "./http-common";
import DocumentModel from "../models/document";

// Navbar APIs
// eslint-disable-next-line
export default new (class DocumentService {
  // Get all members
  async getDocument() {
    return await http
      .get("/documents?pLevel")
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((document) => DocumentModel.get(document))
        );

        return data.sort((a, b) => a.order - b.order);
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
